import { cn } from "@omni/utils/styles";

import { ProductBundles } from "@/components/Product/ProductBundles/productBundles.container";

import { useProductPageContext } from "../../context/productPage.context";

export const ProductPageProductBundlesContainer = () => {
    const { product } = useProductPageContext();
    return (
        <ProductBundles
            product={product}
            className={cn("tw:mb-6")}
        />
    );
};
